import { isThisArrayNotEmpty } from "../../../services/helpers/commonHelpers";
import { OptionType } from "../../../services/helpers/types";
import { ValueObjectType } from "../../organisms/CascaderField/helpers";

export const getCheckboxChecked = (
  option: OptionType,
  subOptionName: string,
  currentValueObject: ValueObjectType
) => {
  const checkboxValue = currentValueObject[option.name];

  if (
    isThisArrayNotEmpty(checkboxValue) &&
    checkboxValue.includes(subOptionName)
  ) {
    return true;
  }

  return false;
};
